import { QueryClient } from 'react-query';

/**
 * Custom React Query Client Configuration
 * Optimized untuk mencegah race condition dan improve stability
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Retry configuration
      retry: 1, // Hanya retry 1x jika gagal (default: 3)
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 3000),
      
      // Caching & Refetch behavior
      staleTime: 5 * 60 * 1000, // Data dianggap fresh selama 5 menit
      cacheTime: 10 * 60 * 1000, // Cache disimpan 10 menit
      
      // Prevent automatic refetch yang bisa trigger race condition
      refetchOnWindowFocus: false, // Jangan refetch saat window focus
      refetchOnMount: false, // Jangan refetch saat component mount jika ada cache
      refetchOnReconnect: false, // Jangan refetch saat reconnect
      
      // Error handling
      suspense: false,
      useErrorBoundary: false,
      
      // Structured to avoid race condition
      structuralSharing: true,
    },
    mutations: {
      retry: 0, // Mutation jangan di-retry
      useErrorBoundary: false,
    },
  },
});

export default queryClient;
